/** Répertorie les différentes actions prises en compte par le bouton d'action. */
export enum EActionButtonType {

	conversation = "conversation",
	form = "form",
	navigation = "navigation",
	position = "position",
	map = "map",
	component = "component"
}